var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9948 15.9954V7.99769C20.9945 7.64707 20.9019 7.3027 20.7264 6.99914C20.551 6.69558 20.2988 6.4435 19.9951 6.26819L12.9971 2.26934C12.6932 2.09385 12.3484 2.00146 11.9974 2.00146C11.6464 2.00146 11.3017 2.09385 10.9977 2.26934L3.99971 6.26819C3.69606 6.4435 3.44385 6.69558 3.26838 6.99914C3.09292 7.3027 3.00036 7.64707 3 7.99769V15.9954C3.00036 16.346 3.09292 16.6904 3.26838 16.9939C3.44385 17.2975 3.69606 17.5496 3.99971 17.7249L10.9977 21.7237C11.3017 21.8992 11.6464 21.9916 11.9974 21.9916C12.3484 21.9916 12.6932 21.8992 12.9971 21.7237L19.9951 17.7249C20.2988 17.5496 20.551 17.2975 20.7264 16.9939C20.9019 16.6904 20.9945 16.346 20.9948 15.9954Z",
    stroke: "#EA6C52",
    strokeWidth: 1.99943
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26953 6.95801L11.997 12.0066L20.7245 6.95801",
    stroke: "#EA6C52",
    strokeWidth: 1.99943
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9961 22.0737V11.9966",
    stroke: "#EA6C52",
    strokeWidth: 1.99943
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.f00c63c836e8668f4ab1ebf7be6528df.svg";
export { ForwardRef as ReactComponent };